/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Edit_CronInputs */

const en_jobs_edit_cron = /** @type {(inputs: Jobs_Edit_CronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit cron`)
};

const he_jobs_edit_cron = /** @type {(inputs: Jobs_Edit_CronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עריכת cron`)
};

/**
* | output |
* | --- |
* | "Edit cron" |
*
* @param {Jobs_Edit_CronInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const jobs_edit_cron = /** @type {((inputs?: Jobs_Edit_CronInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Edit_CronInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_edit_cron(inputs)
	return he_jobs_edit_cron(inputs)
});